import { useReducer, useRef } from 'react';
import { useRouter } from 'next/router';
import { useIsomorphicLayoutEffect } from '@lib/hooks'

const reduce = (state, action) => {
  switch (action.type) {
    case 'update':
      return { ...state, ...action.payload };
    default:
      throw new Error();
  }
}

const initialState = {
  errorMsgTotal: '',
  totalStatus: 'success',
  errorMsgAmount: '',
  amountStatus: 'success',
  errorMsgPrice: '',
  priceStatus: 'success'
};

export const useValidata = () => {
  const [state, dispatch] = useReducer(reduce, initialState);
  const { query } = useRouter();
  const tradingPair = useRef(null);
  const updateValidState = (payload) => {
    dispatch({
      type: 'update',
      payload
    })
  }
  useIsomorphicLayoutEffect(() => {
    if (tradingPair.current !== query?.coinCode) {
      tradingPair.current = query?.coinCode;
      updateValidState(initialState)
    }
  }, [query?.coinCode])
  return {
    state,
    updateValidState
  };
}
